import { defineAsyncComponent } from 'vue'

export const ModalPlayOnApp = defineAsyncComponent(() => import('../ModalPlayOnApp/ModalPlayOnApp.vue'))
